import React from 'react'

export default function ShimmerLoader({ loading = true, width, height, mt, ml ,br }) {
    if (!loading) return null
    return (
        <div className="shimmer" style={{ width: width, height: height, marginTop:mt, marginLeft : ml, borderRadius:br }} />
    )
}
